module.exports = __webpack_public_path__ + "static/images/card_grey.ba8cee6.png";